import { Route, RouteGroup } from '@apps-common/types/routes'
import {
  Dashboard,
  Management,
  MyMonitoring,
  MyMonitoringAccountDetails,
  OrderCreate,
  OrderDetails,
  Orders,
  Receivers,
  Settings,
  UnitActivationCreation,
  UnitActivationDetails,
  UnitActivationEdit,
  UnitActivations,
  UnitControlModify,
  UnitControls,
  UnitCreateMultiple,
  UnitDetailsModify,
  UnitEvents,
  UnitManage,
  UnitNotes,
  Units,
  UnitSchedules,
  UnitTriggers,
  UnitUsers,
  UnitZones
} from '@apps-radionet-portal/pages'

import { MyMonitoringAccountCreate } from '../pages/my-monitoring/MyMonitoringAccountCreate'
import { ReceiverTraffic } from '../pages/receivers/ReceiverTraffic'
import { UnitProgramTaskQueue } from '../pages/units/UnitProgramTaskQueue'
import { UnitProgramTasks } from '../pages/units/UnitProgramTasks'
// import { UnitProgramTasksModify } from '../pages/units/UnitProgramTasksModify'

// top level routes

export const ROUTE_DASHBOARD: Route = {
  key: 'dashboard',
  label: 'Dashboard',
  path: '/dashboard',
  component: Dashboard,
  breadcrumbs: [{ label: 'Dashboard', icon: 'sbDashboard' }],
  icon: 'sbDashboard',
  type: 'private',
  buildPath: () => '/dashboard'
}

export const ROUTE_UNITS: Route = {
  key: 's',
  label: 'Devices',
  path: '/devices',
  component: Units,
  breadcrumbs: [{ label: 'Devices', icon: 'sbUnits' }],
  icon: 'sbUnits',
  type: 'private',
  buildPath: () => '/devices'
}

export const ROUTE_ORDERS: Route = {
  key: 'orders',
  label: 'Orders',
  path: '/orders',
  component: Orders,
  breadcrumbs: [{ label: 'Orders', icon: 'sbOrders' }],
  icon: 'sbOrders',
  type: 'private',
  buildPath: () => '/orders'
}

export const ROUTE_MY_MONITORING: Route = {
  key: 'my-monitoring',
  label: 'My Monitoring',
  path: '/my-monitoring',
  component: MyMonitoring,
  breadcrumbs: [{ label: 'My Monitoring', icon: 'myMonitoringLogoOnly' }],
  icon: 'myMonitoringLogoOnly',
  type: 'private',
  buildPath: () => '/my-monitoring'
}

export const ROUTE_RECEIVERS: Route = {
  key: 'receivers',
  label: 'Receivers',
  path: '/receivers',
  component: Receivers,
  breadcrumbs: [{ label: 'Receivers', icon: 'sbReceivers' }],
  icon: 'sbReceivers',
  type: 'private',
  requiresMonitoringCentre: true,
  buildPath: () => '/receivers'
}

export const ROUTE_NOTIFICATIONS: Route = {
  key: 'notifications',
  label: 'Notifications',
  path: '/notifications',
  // component: Notifications,
  breadcrumbs: [{ label: 'Notifications', icon: 'sbNotifications' }],
  icon: 'sbNotifications',
  type: 'private',
  buildPath: () => '/notifications',
  useCallback: true
}

export const ROUTE_SETTINGS: Route = {
  key: 'settings',
  label: 'Settings',
  path: '/settings',
  component: Settings,
  breadcrumbs: [{ label: 'Settings', icon: 'sbSettings' }],
  icon: 'sbSettings',
  type: 'private',
  buildPath: () => '/settings'
}

export const ROUTE_SETTINGS_PROFILE: Route = {
  key: 'profile',
  label: 'Profile',
  path: `${ROUTE_SETTINGS.path}/profile`,
  component: Settings,
  breadcrumbs: [...ROUTE_SETTINGS.breadcrumbs, { label: 'Profile' }],
  icon: 'sbSettings',
  type: 'private',
  buildPath: () => `${ROUTE_SETTINGS.path}/profile`
}

export const ROUTE_SETTINGS_COMPANY: Route = {
  key: 'Company',
  label: 'Company',
  path: `${ROUTE_SETTINGS.path}/company`,
  component: Settings,
  breadcrumbs: [...ROUTE_SETTINGS.breadcrumbs, { label: 'Company' }],
  icon: 'sbSettings',
  type: 'private',
  buildPath: () => `${ROUTE_SETTINGS.path}/company`
}

export const ROUTE_MANAGEMENT: Route = {
  key: 'management',
  label: 'Management',
  path: '/management',
  component: Management,
  breadcrumbs: [{ label: 'Management', icon: 'sbManagement' }],
  icon: 'sbManagement',
  type: 'super',
  buildPath: () => '/management'
}

// unit tasks route

export const ROUTE_UNIT_PROGRAM_TASKS: Route = {
  key: 'device-tasks',
  label: 'Device Tasks',
  path: '/devices/tasks',
  component: UnitProgramTasks,
  breadcrumbs: [...ROUTE_UNITS.breadcrumbs, { label: 'Tasks' }],
  icon: 'folder',
  type: 'private',
  buildPath: () => '/devices/tasks'
}

// export const ROUTE_UNIT_PROGRAM_TASKS_CREATE: Route = {
//   key: 'device-tasks-create',
//   label: 'Create Task',
//   path: '/devices/tasks/create',
//   component: UnitProgramTasksModify,
//   breadcrumbs: [...ROUTE_UNIT_PROGRAM_TASKS.breadcrumbs, { label: 'Create' }],
//   icon: 'folder',
//   type: 'private',
//   buildPath: (type?: string) => `${ROUTE_UNIT_PROGRAM_TASKS.path}/create${type !== undefined ? `?type=${type}` : ''}`
// }

// export const ROUTE_UNIT_PROGRAM_TASKS_UPDATE: Route = {
//   key: 'device-tasks-update',
//   label: 'Update Task',
//   path: '/devices/tasks/update/:taskId',
//   component: UnitProgramTasksModify,
//   breadcrumbs: [...ROUTE_UNIT_PROGRAM_TASKS.breadcrumbs, { label: 'Update' }],
//   icon: 'folder',
//   type: 'private',
//   buildPath: (taskId: number) => `${ROUTE_UNIT_PROGRAM_TASKS.path}/update/:taskId`.replace(':taskId', taskId?.toString())
// }

export const ROUTE_UNIT_PROGRAM_TASK_QUEUE: Route = {
  key: 'device-tasks-queue',
  label: 'Task Queue',
  path: '/devices/tasks/:taskId/queue',
  component: UnitProgramTaskQueue,
  breadcrumbs: [...ROUTE_UNIT_PROGRAM_TASKS.breadcrumbs, { label: 'Queue' }],
  icon: 'folder',
  type: 'private',
  buildPath: (taskId: number, queueId: number) =>
    `${ROUTE_UNIT_PROGRAM_TASKS.path}/:taskId/queue{query}`
      .replace(':taskId', taskId?.toString())
      .replace('{query}', queueId ? `?queueId=${queueId}` : '')
}

export const ROUTE_UNIT_PROGRAM_TASK_QUEUE_CREATE: Route = {
  key: 'device-tasks-queue-create',
  label: 'Task Queue',
  path: '/devices/tasks/:taskId/queue/create',
  component: UnitProgramTaskQueue,
  breadcrumbs: [...ROUTE_UNIT_PROGRAM_TASK_QUEUE.breadcrumbs, { label: 'Create' }],
  icon: 'folder',
  type: 'private',
  buildPath: (taskId: number) => `${ROUTE_UNIT_PROGRAM_TASKS.path}/:taskId/queue/create`.replace(':taskId', taskId?.toString())
}

export const ROUTE_UNIT_PROGRAM_TASK_QUEUE_UPDATE: Route = {
  key: 'device-tasks-queue-update',
  label: 'Task Queue',
  path: '/devices/tasks/:taskId/queue/update/:taskQueueId',
  component: UnitProgramTaskQueue,
  breadcrumbs: [...ROUTE_UNIT_PROGRAM_TASK_QUEUE.breadcrumbs, { label: 'Update' }],
  icon: 'folder',
  type: 'private',
  buildPath: (taskId: number, taskQueueId: number) =>
    `${ROUTE_UNIT_PROGRAM_TASKS.path}/:taskId/queue/update/:taskQueueId`
      .replace(':taskId', taskId?.toString())
      .replace(':taskQueueId', taskQueueId?.toString())
}

// unit activations

export const ROUTE_UNIT_ACTIVATIONS: Route = {
  key: 'device-activations',
  label: 'Device Activations',
  path: '/devices/activations',
  component: UnitActivations,
  breadcrumbs: [...ROUTE_UNITS.breadcrumbs, { label: 'Activations', icon: 'srActivations' }],
  icon: 'srActivations',
  type: 'private',
  buildPath: () => '/devices/activations'
}

export const ROUTE_UNIT_ACTIVATION_DETAILS: Route = {
  key: 'device-activation-details',
  label: 'Device activation',
  path: '/devices/activations/details/:activationId',
  component: UnitActivationDetails,
  breadcrumbs: [...ROUTE_UNIT_ACTIVATIONS.breadcrumbs, { label: 'Details' }],
  icon: 'folder',
  type: 'private',
  buildPath: (unitActivationId: number) =>
    '/devices/activations/details/:activationId'.replace(':activationId', unitActivationId?.toString() || '')
}

export const ROUTE_CREATE_UNIT_ACTIVATION: Route = {
  key: 'create-device-activation',
  label: 'Create activation',
  path: '/devices/activations/create',
  component: UnitActivationCreation,
  breadcrumbs: [...ROUTE_UNIT_ACTIVATIONS.breadcrumbs, { label: 'Create' }],
  icon: 'folder',
  type: 'private',
  buildPath: () => '/devices/activations/create'
}

export const ROUTE_EDIT_UNIT_ACTIVATION: Route = {
  key: 'edit-device-activation',
  label: 'Edit activation',
  path: '/devices/activations/edit/:activationId',
  component: UnitActivationEdit,
  breadcrumbs: [...ROUTE_UNIT_ACTIVATIONS.breadcrumbs, { label: 'Edit' }],
  icon: 'folder',
  type: 'private',
  buildPath: (unitActivationId: number) => '/devices/activations/edit/:activationId'.replace(':activationId', unitActivationId?.toString())
}

// export const ROUTE_UNIT_MONITORING_CHANGE_DETAILS: Route = {
//   key: 'device-monitoring-change-details',
//   label: 'Monitoring change',
//   path: '/devices/monitoring-changes/:monitoringChangeId',
//   component: UnitMonitoringChangeDetails,
//   breadcrumbs: [...ROUTE_SERVICE_REQUESTS.breadcrumbs, { label: 'Monitoring change details' }],
//   icon: 'folder',
//   type: 'private',
//   buildPath: (monitoringChangeId: number) =>
//     '/service-requests/monitoring-change/:monitoringChangeId'.replace(':monitoringChangeId', monitoringChangeId?.toString())
// }

// export const ROUTE_SERVICE_REQUESTS_CREATE_MONITORING_CHANGE: Route = {
//   key: 'service-requests-create-monitoring-change',
//   label: 'Create monitoring change',
//   path: '/service-requests/create-monitoring-change',
//   component: UnitMonitoringChangeCreate,
//   breadcrumbs: [...ROUTE_SERVICE_REQUESTS.breadcrumbs, { label: 'Create monitoring change' }],
//   icon: 'folder',
//   type: 'private',
//   buildPath: () => '/service-requests/create-monitoring-change'
// }

// export const ROUTE_SERVICE_REQUESTS_EDIT_MONITORING_CHANGE: Route = {
//   key: 'service-requests-edit-monitoring-change',
//   label: 'Edit monitoring change',
//   path: '/service-requests/edit-monitoring-change/:monitoringChangeId',
//   component: UnitMonitoringChangeEdit,
//   breadcrumbs: [...ROUTE_SERVICE_REQUESTS.breadcrumbs, { label: 'Edit monitoring change' }],
//   icon: 'folder',
//   type: 'private',
//   buildPath: (monitoringChangeId: number) =>
//     '/service-requests/edit-monitoring-change/:monitoringChangeId'.replace(':monitoringChangeId', monitoringChangeId?.toString())
// }

// bottom level routes

export const ROUTE_UNIT_MANAGE: Route = {
  key: 'device-manage',
  label: 'Device management',
  path: '/devices/:status/:unitId',
  component: UnitManage,
  breadcrumbs: [...ROUTE_UNITS.breadcrumbs, { label: 'Manage' }],
  icon: 'folder',
  type: 'private',
  buildPath: (status: string, unitId: string) => '/devices/:status/:unitId'.replace(':status', status).replace(':unitId', unitId)
}

// unit details routes

export const ROUTE_CREATE_UNIT: Route = {
  key: 'create-device',
  label: 'Create Device',
  path: `${ROUTE_UNITS.path}/create`,
  component: UnitDetailsModify,
  breadcrumbs: [...ROUTE_UNITS.breadcrumbs, { label: 'Create' }],
  icon: 'folder',
  type: 'private',
  buildPath: () => `${ROUTE_UNITS.path}/create`
}

export const ROUTE_CREATE_MULTIPLE_UNIT: Route = {
  key: 'create-device-multiple',
  label: 'Create Devices',
  path: `${ROUTE_UNITS.path}/create-multiple`,
  component: UnitCreateMultiple,
  breadcrumbs: [...ROUTE_UNITS.breadcrumbs, { label: 'Create Multiple' }],
  icon: 'folder',
  type: 'private',
  buildPath: () => `${ROUTE_UNITS.path}/create-multiple`
}

export const ROUTE_UNIT_DETAILS: Route = {
  key: 'edit-device-details',
  label: 'Edit device details',
  path: `${ROUTE_UNIT_MANAGE.path}/details`,
  component: UnitDetailsModify,
  breadcrumbs: [...ROUTE_UNIT_MANAGE.breadcrumbs, { label: 'Details' }],
  icon: 'folder',
  type: 'private',
  buildPath: (status: string, unitId: string) => `${ROUTE_UNIT_MANAGE.path}/details`.replace(':status', status).replace(':unitId', unitId)
}

export const ROUTE_UNIT_EVENTS: Route = {
  key: 'device-events',
  label: 'Unit events',
  path: `${ROUTE_UNIT_MANAGE.path}/events`,
  component: UnitEvents,
  breadcrumbs: [...ROUTE_UNIT_MANAGE.breadcrumbs, { label: 'Events' }],
  icon: 'folder',
  type: 'private',
  buildPath: (status: string, unitId: string) => `${ROUTE_UNIT_MANAGE.path}/events`.replace(':status', status).replace(':unitId', unitId)
}

export const ROUTE_UNIT_CONTROLS: Route = {
  key: 'device-controls',
  label: 'Controls',
  path: `${ROUTE_UNIT_MANAGE.path}/controls`,
  component: UnitControls,
  breadcrumbs: [...ROUTE_UNIT_MANAGE.breadcrumbs, { label: 'Controls' }],
  icon: 'folder',
  type: 'private',
  buildPath: (status: string, unitId: string) => `${ROUTE_UNIT_MANAGE.path}/controls`.replace(':status', status).replace(':unitId', unitId)
}

export const ROUTE_CREATE_UNIT_CONTROL: Route = {
  key: 'create-device-control',
  label: 'Create Control',
  path: `${ROUTE_UNIT_MANAGE.path}/create-control`,
  component: UnitControlModify,
  breadcrumbs: [...ROUTE_UNIT_MANAGE.breadcrumbs, { label: 'Create Control' }],
  icon: 'folder',
  type: 'private',
  buildPath: (status: string, unitId: string) =>
    `${ROUTE_UNIT_MANAGE.path}/create-control`.replace(':status', status).replace(':unitId', unitId)
}

export const ROUTE_EDIT_UNIT_CONTROL: Route = {
  key: 'edit-device-control',
  label: 'Edit Control',
  path: `${ROUTE_UNIT_MANAGE.path}/edit-control/:controlId`,
  component: UnitControlModify,
  breadcrumbs: [...ROUTE_UNIT_MANAGE.breadcrumbs, { label: 'Edit Control' }],
  icon: 'folder',
  type: 'private',
  buildPath: (status: string, unitId: string, controlId: number) =>
    `${ROUTE_UNIT_MANAGE.path}/edit-control/:controlId`
      .replace(':status', status)
      .replace(':unitId', unitId)
      .replace(':controlId', controlId.toString())
}

export const ROUTE_UNIT_NOTES: Route = {
  key: 'device-notes',
  label: 'Notes',
  path: `${ROUTE_UNIT_MANAGE.path}/notes`,
  component: UnitNotes,
  breadcrumbs: [...ROUTE_UNIT_MANAGE.breadcrumbs, { label: 'Notes' }],
  icon: 'folder',
  type: 'private',
  buildPath: (status: string, unitId: string) => `${ROUTE_UNIT_MANAGE.path}/notes`.replace(':status', status).replace(':unitId', unitId)
}

export const ROUTE_UNIT_USERS: Route = {
  key: 'device-users',
  label: 'Users',
  path: `${ROUTE_UNIT_MANAGE.path}/users`,
  component: UnitUsers,
  breadcrumbs: [...ROUTE_UNIT_MANAGE.breadcrumbs, { label: 'Users' }],
  icon: 'folder',
  type: 'private',
  buildPath: (status: string, unitId: string) => `${ROUTE_UNIT_MANAGE.path}/users`.replace(':status', status).replace(':unitId', unitId)
}

export const ROUTE_UNIT_ZONES: Route = {
  key: 'device-zones',
  label: 'Zones',
  path: `${ROUTE_UNIT_MANAGE.path}/zones`,
  component: UnitZones,
  breadcrumbs: [...ROUTE_UNIT_MANAGE.breadcrumbs, { label: 'Zones' }],
  icon: 'folder',
  type: 'private',
  buildPath: (status: string, unitId: string) => `${ROUTE_UNIT_MANAGE.path}/zones`.replace(':status', status).replace(':unitId', unitId)
}

export const ROUTE_UNIT_SCHEDULES: Route = {
  key: 'device-schedules',
  label: 'Schedules',
  path: `${ROUTE_UNIT_MANAGE.path}/schedules`,
  component: UnitSchedules,
  breadcrumbs: [...ROUTE_UNIT_MANAGE.breadcrumbs, { label: 'Schedules' }],
  icon: 'folder',
  type: 'private',
  buildPath: (status: string, unitId: string) => `${ROUTE_UNIT_MANAGE.path}/schedules`.replace(':status', status).replace(':unitId', unitId)
}

// export const ROUTE_CREATE_UNIT_SCHEDULE: Route = {
//   key: 'device-schedule-create',
//   label: 'Schedules',
//   path: `${ROUTE_UNIT_SCHEDULES.path}/create-schedule`,
//   component: UnitScheduleModify,
//   breadcrumbs: [...ROUTE_UNIT_SCHEDULES.breadcrumbs, { label: 'Create' }],
//   icon: 'folder',
//   type: 'private',
//   buildPath: (status: string, unitId: string) =>
//     `${ROUTE_UNIT_SCHEDULES.path}/create-schedule`.replace(':status', status).replace(':unitId', unitId)
// }

// export const ROUTE_EDIT_UNIT_SCHEDULE: Route = {
//   key: 'device-schedule-edit',
//   label: 'Schedules',
//   path: `${ROUTE_UNIT_SCHEDULES.path}/:scheduleId`,
//   component: UnitScheduleModify,
//   breadcrumbs: [...ROUTE_UNIT_SCHEDULES.breadcrumbs, { label: 'Edit' }],
//   icon: 'folder',
//   type: 'private',
//   buildPath: (status: string, unitId: string, scheduleId: number) =>
//     `${ROUTE_UNIT_SCHEDULES.path}/:scheduleId`
//       .replace(':status', status)
//       .replace(':unitId', unitId)
//       .replace(':scheduleId', scheduleId.toString())
// }

export const ROUTE_UNIT_TRIGGERS: Route = {
  key: 'device-triggers',
  label: 'Triggers',
  path: `${ROUTE_UNIT_MANAGE.path}/triggers`,
  component: UnitTriggers,
  breadcrumbs: [...ROUTE_UNIT_MANAGE.breadcrumbs, { label: 'Triggers' }],
  icon: 'folder',
  type: 'private',
  buildPath: (status: string, unitId: string) => `${ROUTE_UNIT_MANAGE.path}/triggers`.replace(':status', status).replace(':unitId', unitId)
}

// export const ROUTE_CREATE_UNIT_TRIGGER: Route = {
//   key: 'device-triggers-create',
//   label: 'Triggers',
//   path: `${ROUTE_UNIT_TRIGGERS.path}/create-trigger`,
//   component: UnitTriggerModify,
//   breadcrumbs: [...ROUTE_UNIT_TRIGGERS.breadcrumbs, { label: 'Create' }],
//   icon: 'folder',
//   type: 'private',
//   buildPath: (status: string, unitId: string) =>
//     `${ROUTE_UNIT_TRIGGERS.path}/create-trigger`.replace(':status', status).replace(':unitId', unitId)
// }

// export const ROUTE_EDIT_UNIT_TRIGGER: Route = {
//   key: 'device-triggers-edit',
//   label: 'Triggers',
//   path: `${ROUTE_UNIT_TRIGGERS.path}/:triggerId`,
//   component: UnitTriggerModify,
//   breadcrumbs: [...ROUTE_UNIT_TRIGGERS.breadcrumbs, { label: 'Edit' }],
//   icon: 'folder',
//   type: 'private',
//   buildPath: (status: string, unitId: string, triggerId: number) =>
//     `${ROUTE_UNIT_TRIGGERS.path}/:triggerId`
//       .replace(':status', status)
//       .replace(':unitId', unitId)
//       .replace(':triggerId', triggerId.toString())
// }

export const ROUTE_CREATE_ORDER: Route = {
  key: 'create-order',
  label: 'Create Order',
  path: `${ROUTE_ORDERS.path}/create`,
  component: OrderCreate,
  breadcrumbs: [...ROUTE_ORDERS.breadcrumbs, { label: 'Create' }],
  icon: 'folder',
  type: 'private',
  buildPath: () => `${ROUTE_ORDERS.path}/create`
}

export const ROUTE_ORDER_DETAILS: Route = {
  key: 'order-details',
  label: 'Order details',
  path: `${ROUTE_ORDERS.path}/details/:orderId`,
  component: OrderDetails,
  breadcrumbs: [...ROUTE_ORDERS.breadcrumbs, { label: 'Details' }],
  icon: 'folder',
  type: 'private',
  buildPath: (orderId: number) => `${ROUTE_ORDERS.path}/details/:orderId`.replace(':orderId', orderId.toString())
}

export const ROUTE_MY_MONITORING_ACCOUNT_CREATE: Route = {
  key: 'my-monitoring-account-create',
  label: 'My Monitoring Account Create',
  path: `${ROUTE_MY_MONITORING.path}/account/create`,
  component: MyMonitoringAccountCreate,
  breadcrumbs: [{ label: 'My Monitoring', icon: 'myMonitoringLogoOnly' }, { label: 'Account' }, { label: 'Create' }],
  icon: 'folder',
  type: 'private',
  buildPath: () => `${ROUTE_MY_MONITORING.path}/account/create`
}

export const ROUTE_MY_MONITORING_ACCOUNT_DETAILS: Route = {
  key: 'my-monitoring-account-details',
  label: 'My Monitoring Account Details',
  path: `${ROUTE_MY_MONITORING.path}/account/details/:accountId`,
  component: MyMonitoringAccountDetails,
  breadcrumbs: [{ label: 'My Monitoring', icon: 'myMonitoringLogoOnly' }, { label: 'Account' }, { label: 'Details' }],
  icon: 'folder',
  type: 'private',
  buildPath: (accountId: number) => `${ROUTE_MY_MONITORING.path}/account/details/:accountId`.replace(':accountId', accountId.toString())
}

// receivers nested routes

export const ROUTE_RECEIVERS_TRAFFIC: Route = {
  key: 'receivers-traffic',
  label: 'Receiver Traffic',
  path: `${ROUTE_RECEIVERS.path}/traffic/:serverId`,
  component: ReceiverTraffic,
  breadcrumbs: [{ label: 'Receivers', icon: 'sbReceivers' }, { label: 'Traffic' }],
  icon: 'sbReceivers',
  type: 'private',
  requiresMonitoringCentre: true,
  buildPath: (serverId: string, companyId?: string) =>
    `${ROUTE_RECEIVERS.path}/traffic/:serverId${!!companyId ? `?companyId=${companyId}` : ''}`.replace(':serverId', serverId.toString())
}

export const SIDEBAR_ROUTES: Route[] = [
  ROUTE_DASHBOARD,
  ROUTE_UNITS,
  ROUTE_ORDERS,
  // ROUTE_SERVICE_REQUESTS,
  ROUTE_MY_MONITORING,
  ROUTE_RECEIVERS,
  // ROUTE_NOTIFICATIONS,
  ROUTE_SETTINGS,
  ROUTE_MANAGEMENT
]

export const PRIVATE_ROUTES: RouteGroup[] = [
  {
    key: 'route-group-dashboard',
    routes: [ROUTE_DASHBOARD]
  },
  {
    key: 'route-group-units',
    routes: [
      ROUTE_UNITS,
      ROUTE_CREATE_UNIT,
      ROUTE_CREATE_MULTIPLE_UNIT,

      ROUTE_UNIT_PROGRAM_TASKS,
      // ROUTE_UNIT_PROGRAM_TASKS_CREATE,
      // ROUTE_UNIT_PROGRAM_TASKS_UPDATE,
      ROUTE_UNIT_PROGRAM_TASK_QUEUE,
      ROUTE_UNIT_PROGRAM_TASK_QUEUE_CREATE,
      ROUTE_UNIT_PROGRAM_TASK_QUEUE_UPDATE,
      ROUTE_UNIT_MANAGE,
      ROUTE_UNIT_DETAILS,
      ROUTE_UNIT_EVENTS,
      ROUTE_CREATE_UNIT_CONTROL,
      ROUTE_EDIT_UNIT_CONTROL,
      ROUTE_UNIT_USERS,
      ROUTE_UNIT_ZONES,
      ROUTE_UNIT_NOTES,
      ROUTE_UNIT_SCHEDULES,
      // ROUTE_CREATE_UNIT_SCHEDULE,
      // ROUTE_EDIT_UNIT_SCHEDULE,
      ROUTE_UNIT_TRIGGERS,
      // ROUTE_CREATE_UNIT_TRIGGER,
      // ROUTE_EDIT_UNIT_TRIGGER,

      ROUTE_UNIT_ACTIVATIONS,
      ROUTE_CREATE_UNIT_ACTIVATION,
      ROUTE_UNIT_ACTIVATION_DETAILS,
      ROUTE_EDIT_UNIT_ACTIVATION
    ]
  },
  {
    key: 'route-group-orders',
    routes: [ROUTE_ORDERS, ROUTE_CREATE_ORDER, ROUTE_ORDER_DETAILS]
  },
  {
    key: 'route-group-my-monitoring',
    routes: [ROUTE_MY_MONITORING, ROUTE_MY_MONITORING_ACCOUNT_CREATE, ROUTE_MY_MONITORING_ACCOUNT_DETAILS]
  },
  {
    key: 'route-group-receivers',
    routes: [ROUTE_RECEIVERS, ROUTE_RECEIVERS_TRAFFIC]
  },
  {
    key: 'route-group-settings',
    routes: [ROUTE_SETTINGS, ROUTE_SETTINGS_PROFILE, ROUTE_SETTINGS_COMPANY]
  },
  {
    key: 'route-group-management',
    routes: [ROUTE_MANAGEMENT]
  }
]
